export default __webpack_public_path__ + "static/media/SOLUCIONESPV_FOOTER.5620e7ac.png";